export enum EkranKoncowyActionsType {
  KLIKNIETO_DODAJ_DOKUMENTY = '[Ekran Koncowy] Kliknieto dodaj dokumenty',
}
